import { RouteItemDef } from "@/types/app.types";
import DefaultLayout from "../layouts/DefaultLayout";
import FriendListScreen from "../screens/FriendList";
import FriendSuggestionsScreen from "../screens/FriendSuggestions/FriendSuggestionsScreen";
import FriendRequestsScreen from "../screens/FriendRequests/FriendRequestsScreen";
import { FriendsPathsEnum } from "../constants/friends";

export const FRIENDS_ROUTES: RouteItemDef[] = [
  {
    id: FriendsPathsEnum.FRIENDS,
    path: FriendsPathsEnum.FRIENDS,
    component: DefaultLayout,
    children: [
      {
        id: FriendsPathsEnum.MY_FRIENDS,
        path: FriendsPathsEnum.MY_FRIENDS,
        component: FriendListScreen,
      },

      {
        id: FriendsPathsEnum.SUGGESTIONS,
        path: FriendsPathsEnum.SUGGESTIONS,
        component: () => <FriendSuggestionsScreen />,
      },
      {
        id: FriendsPathsEnum.REQUEST_FRIENDS,
        path: FriendsPathsEnum.REQUEST_FRIENDS,
        component: () => <FriendRequestsScreen />,
      },
    ],
  },
];
